import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        { attrs: { align: "center" } },
        [
          _c(
            VCol,
            {
              staticClass: "d-flex flex-column align-center mb-md-10",
              attrs: { cols: "12", md: "6" },
            },
            [
              _c(VAvatar, { attrs: { size: "220px" } }, [
                _c("img", {
                  attrs: { src: _vm.imagemPreview, alt: "Imagem do Perfil" },
                }),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12", md: "4" } },
            [
              _c("h1", { staticClass: "title primary--text pb-md-6" }, [
                _vm._v(" " + _vm._s(_vm.usuario.nome) + " "),
              ]),
              _c(VRow, { staticClass: "my-md-3" }, [
                _c(
                  "span",
                  [
                    _c(VIcon, { staticClass: "primary--text" }, [
                      _vm._v("pin"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.usuario.siape) + " "),
                  ],
                  1
                ),
              ]),
              _c(VRow, { staticClass: "my-md-3" }, [
                _c(
                  "span",
                  [
                    _c(VIcon, { staticClass: "primary--text" }, [
                      _vm._v("alternate_email"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.usuario.email) + " "),
                  ],
                  1
                ),
              ]),
              _c(VRow, { staticClass: "my-md-3" }, [
                _c(
                  "span",
                  [
                    _c(VIcon, { staticClass: "primary--text" }, [
                      _vm._v("engineering"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.usuario.cargo) + " "),
                  ],
                  1
                ),
              ]),
              _c(VRow, { staticClass: "my-md-3" }, [
                _c(
                  "span",
                  [
                    _c(VIcon, { staticClass: "primary--text" }, [
                      _vm._v("account_balance"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.usuario.unidade.nome) + " "),
                  ],
                  1
                ),
              ]),
              _vm.usuario.unidade.unidadePai
                ? _c(VRow, { staticClass: "my-md-3" }, [
                    _c(
                      "span",
                      [
                        _c(VIcon, { staticClass: "primary--text" }, [
                          _vm._v("account_balance"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.usuario.unidade.unidadePai.nome) +
                            " "
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.usuario.funcao
                ? _c(VRow, { staticClass: "my-md-3" }, [
                    _c(
                      "span",
                      [
                        _c(VIcon, { staticClass: "primary--text" }, [
                          _vm._v("badge"),
                        ]),
                        _vm._v(" " + _vm._s(_vm.usuario.funcao) + " "),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.usuario.contato
                ? _c(VRow, { staticClass: "my-md-3" }, [
                    _c(
                      "span",
                      [
                        _c(VIcon, { staticClass: "primary--text" }, [
                          _vm._v("phone"),
                        ]),
                        _vm._v(" " + _vm._s(_vm.usuario.contato) + " "),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.perfil.deficiente
                ? _c(VRow, { staticClass: "my-md-3" }, [
                    _c(
                      "span",
                      { staticClass: "primary--text" },
                      [
                        _c(VIcon, { staticClass: "primary--text" }, [
                          _vm._v("accessible"),
                        ]),
                        _c("b", [_vm._v("Condição de deficiência: ")]),
                      ],
                      1
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          !_vm.perfil.deficiencias.length > 0
                            ? "Sim"
                            : _vm.deficiencias
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.perfil.observacoesDeficiencias != null &&
              _vm.perfil.observacoesDeficiencias != ""
                ? _c(VRow, { staticClass: "my-md-3" }, [
                    _c(
                      "span",
                      { staticClass: "primary--text" },
                      [
                        _c(VIcon, { staticClass: "primary--text" }, [
                          _vm._v("settings_accessibility"),
                        ]),
                        _c("b", [
                          _vm._v(
                            "Tendo em vista a sua condição, como seria um ambiente de trabalho adaptado às suas necessidades? "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm.perfil.observacoesDeficiencias)),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "align-center" },
        [
          _c(VCol, { attrs: { cols: "2" } }),
          _c(
            VCol,
            { attrs: { cols: "8" } },
            [
              _c(
                VTimeline,
                { attrs: { "align-top": "", clipped: "", dense: "" } },
                [
                  _c(
                    VTimelineItem,
                    {
                      staticClass: "white--text primary--text align-center",
                      attrs: { "fill-dot": "", icon: "school", large: "" },
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "title primary--text text--darken-1 text-no-wrap",
                        },
                        [_vm._v(" FORMAÇÃO ")]
                      ),
                    ]
                  ),
                  _c(VTimelineItem, { attrs: { "hide-dot": "" } }, [
                    _c(
                      "h3",
                      { staticClass: "subtitle-1 primary--text ml-n4" },
                      [_vm._v(" FORMAÇÃO ACADÊMICA ")]
                    ),
                  ]),
                  _vm._l(_vm.escolaridades, function (escolaridade) {
                    return _c(
                      VTimelineItem,
                      {
                        key: "escolaridade_" + escolaridade.id,
                        staticClass: "align-top",
                        attrs: { small: "" },
                      },
                      [
                        _c(
                          VRow,
                          { staticClass: "mt-n3" },
                          [
                            _c(VCol, { attrs: { cols: "6" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getCursoInstituicao(escolaridade)
                                  ) +
                                  " "
                              ),
                              _c("ul", [
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Nível:"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        escolaridade.nivelEscolaridade.descricao
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Situação:"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(escolaridade.status.descricao) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "3" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatDate(escolaridade.inicio)
                                    ) +
                                    " - " +
                                    _vm._s(
                                      escolaridade.termino
                                        ? _vm.formatDate(escolaridade.termino)
                                        : "até hoje"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm.areasPesquisa.length > 0
                    ? _c(
                        VTimelineItem,
                        { attrs: { small: "" } },
                        [
                          _c(
                            VRow,
                            { staticClass: "mt-n3" },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "6" } },
                                [
                                  _c("span", { staticClass: "primary--text" }, [
                                    _vm._v("Áreas de Pesquisa"),
                                  ]),
                                  _vm._l(_vm.areasPesquisa, function (area) {
                                    return _c(
                                      "ul",
                                      { key: "areaPesquisa_" + area.id },
                                      [
                                        _c("li", [
                                          _vm._v(" " + _vm._s(area.nome) + " "),
                                        ]),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VTimelineItem,
                    { staticClass: "mb-2", attrs: { "hide-dot": "" } },
                    [
                      _c(
                        "h3",
                        { staticClass: "subtitle-1 primary--text ml-n4" },
                        [_vm._v(" FORMAÇÃO COMPLEMENTAR ")]
                      ),
                    ]
                  ),
                  _vm.cursosCapacitacao.length > 0
                    ? _c(
                        VTimelineItem,
                        { staticClass: "mb-2", attrs: { "hide-dot": "" } },
                        [
                          _c(
                            "h4",
                            { staticClass: "subtitle-2 primary--text" },
                            [
                              _vm._v(
                                " CURSOS DE CAPACITAÇÃO (Total: " +
                                  _vm._s(_vm.totalHorasCursoCapacitacao) +
                                  "H) "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._l(_vm.cursosCapacitacao, function (curso) {
                    return _c(
                      VTimelineItem,
                      {
                        key: "cursoCapacitacao_" + curso.id,
                        staticClass: "align-top",
                        attrs: { small: "" },
                      },
                      [
                        _c(
                          VRow,
                          { staticClass: "mt-n3" },
                          [
                            _c(VCol, { attrs: { cols: "6" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(curso.nome) +
                                  " - " +
                                  _vm._s(curso.instituicao) +
                                  " "
                              ),
                              _c("ul", [
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Área:"),
                                  ]),
                                  _vm._v(" " + _vm._s(curso.area.nome) + " "),
                                ]),
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Carga Horária:"),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(curso.cargaHoraria) + "h "
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "3" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatDate(curso.inicio)) +
                                    " - " +
                                    _vm._s(_vm.formatDate(curso.termino)) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm.perfil.instrutorCapacitacao &&
                  _vm.cursosInstrutorCapacitacao.length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            VTimelineItem,
                            {
                              staticClass: "mb-2 mt-2",
                              attrs: { "hide-dot": "" },
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "subtitle-2 primary--text" },
                                [_vm._v(" INSTRUTOR DE CAPACITAÇÃO ")]
                              ),
                            ]
                          ),
                          _vm._l(
                            _vm.cursosInstrutorCapacitacao,
                            function (instrutor) {
                              return _c(
                                VTimelineItem,
                                {
                                  key: "instrutorCapacitacao_" + instrutor.id,
                                  staticClass: "align-top",
                                  attrs: { small: "" },
                                },
                                [
                                  _c(
                                    VRow,
                                    { staticClass: "mt-n3" },
                                    [
                                      _c(VCol, { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          " " + _vm._s(instrutor.nome) + " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.idiomas.length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            VTimelineItem,
                            {
                              staticClass: "mb-2 mt-2",
                              attrs: { "hide-dot": "" },
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "subtitle-2 primary--text" },
                                [_vm._v(" IDIOMAS ")]
                              ),
                            ]
                          ),
                          _vm._l(_vm.idiomas, function (idioma) {
                            return _c(
                              VTimelineItem,
                              {
                                key: "idioma_" + idioma.id,
                                staticClass: "align-top",
                                attrs: { small: "" },
                              },
                              [
                                _c(
                                  VRow,
                                  { staticClass: "mt-n3" },
                                  [
                                    _c(VCol, { attrs: { cols: "6" } }, [
                                      _vm._v(
                                        " " + _vm._s(idioma.nomeIdioma) + " "
                                      ),
                                      _c("ul", [
                                        _c("li", [
                                          _c(
                                            "b",
                                            { staticClass: "primary--text" },
                                            [_vm._v("Compreensão:")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                idioma.compreensao.descricao
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("li", [
                                          _c(
                                            "b",
                                            { staticClass: "primary--text" },
                                            [_vm._v("Escrita:")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(idioma.escrita.descricao) +
                                              " "
                                          ),
                                        ]),
                                        _c("li", [
                                          _c(
                                            "b",
                                            { staticClass: "primary--text" },
                                            [_vm._v("Fala:")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(idioma.fala.descricao) +
                                              " "
                                          ),
                                        ]),
                                        _c("li", [
                                          _c(
                                            "b",
                                            { staticClass: "primary--text" },
                                            [_vm._v("Leitura:")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(idioma.leitura.descricao) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    VTimelineItem,
                    {
                      staticClass: "white--text primary--text align-center",
                      attrs: { "fill-dot": "", icon: "handyman", large: "" },
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "title primary--text text--darken-1 text-no-wrap",
                        },
                        [_vm._v(" ATUAÇÃO PROFISSIONAL ")]
                      ),
                    ]
                  ),
                  _c(VTimelineItem, { attrs: { "hide-dot": "" } }, [
                    _c(
                      "h3",
                      { staticClass: "subtitle-1 primary--text ml-n4" },
                      [
                        _vm._v(
                          " EXPERIÊNCIAS PROFISSIONAIS (Total: " +
                            _vm._s(
                              _vm.getDescricaoTempo(
                                _vm.totalHorasExperienciaProfissional
                              )
                            ) +
                            ") "
                        ),
                      ]
                    ),
                  ]),
                  _vm._l(_vm.experienciasProfissionais, function (ep) {
                    return _c(
                      VTimelineItem,
                      {
                        key: "experienciaProfissional_" + ep.id,
                        staticClass: "align-top",
                        attrs: { small: "" },
                      },
                      [
                        _c(
                          VRow,
                          { staticClass: "mt-n3" },
                          [
                            _c(VCol, { attrs: { cols: "6" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(ep.nomeCargo) +
                                  " - " +
                                  _vm._s(ep.instituicao) +
                                  " "
                              ),
                              _c("ul", [
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Setor:"),
                                  ]),
                                  _vm._v(" " + _vm._s(ep.nomeSetor) + " "),
                                ]),
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Vínculo:"),
                                  ]),
                                  _vm._v(" " + _vm._s(ep.nomeVinculo) + " "),
                                ]),
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Função:"),
                                  ]),
                                  _vm._v(" " + _vm._s(ep.nomeFuncao) + " "),
                                ]),
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Nível de Gratificação:"),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(ep.nomeNivelGratificacao) + " "
                                  ),
                                ]),
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Situação:"),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(ep.status.descricao) + " "
                                  ),
                                ]),
                                _c("li", [
                                  _c("b", { staticClass: "primary--text" }, [
                                    _vm._v("Tempo de Experiência:"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getDescricaoTempo(
                                          _vm.getCargaHoraria(ep)
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "3" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatDate(ep.inicio)) +
                                    " - " +
                                    _vm._s(
                                      ep.status && ep.status.id === "ATUAL"
                                        ? "até hoje"
                                        : _vm.formatDate(ep.termino)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm.areasProfissional.length > 0
                    ? _c(
                        VTimelineItem,
                        { attrs: { small: "" } },
                        [
                          _c(
                            VRow,
                            { staticClass: "mt-n3" },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "6" } },
                                [
                                  _c("span", { staticClass: "primary--text" }, [
                                    _vm._v("Áreas de Atuação"),
                                  ]),
                                  _vm._l(
                                    _vm.areasProfissional,
                                    function (area) {
                                      return _c(
                                        "ul",
                                        { key: "areaProfissional_" + area.id },
                                        [
                                          _c("li", [
                                            _vm._v(
                                              " " + _vm._s(area.nome) + " "
                                            ),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VTimelineItem,
                    {
                      staticClass: "white--text primary--text align-center",
                      attrs: { "fill-dot": "", icon: "favorite", large: "" },
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "title primary--text text--darken-1 text-no-wrap",
                        },
                        [_vm._v(" ATIVIDADES DE INTERESSE ")]
                      ),
                    ]
                  ),
                  _c(VTimelineItem, { attrs: { "hide-dot": "" } }, [
                    _c(
                      "h3",
                      { staticClass: "subtitle-1 primary--text ml-n4" },
                      [_vm._v(" ÁREAS DE CULTURA E ARTE ")]
                    ),
                  ]),
                  _vm._l(_vm.areasCultura, function (area) {
                    return _c(
                      VTimelineItem,
                      { key: "areaCultura_" + area.id, attrs: { small: "" } },
                      [
                        _c(
                          VRow,
                          { staticClass: "mt-n3" },
                          [
                            _c(VCol, { attrs: { cols: "6" } }, [
                              _vm._v(" " + _vm._s(area.nome) + " "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm.perfil.instrutorCultura &&
                  _vm.cursosInstrutorCultura.length > 0
                    ? _c(
                        "div",
                        [
                          _c(VTimelineItem, { attrs: { "hide-dot": "" } }, [
                            _c(
                              "h3",
                              { staticClass: "subtitle-1 primary--text ml-n4" },
                              [_vm._v(" INSTRUTOR DE CULTURA E ARTE ")]
                            ),
                          ]),
                          _vm._l(
                            _vm.cursosInstrutorCultura,
                            function (instrutor) {
                              return _c(
                                VTimelineItem,
                                {
                                  key: "instrutorCultura_" + instrutor.id,
                                  attrs: { small: "" },
                                },
                                [
                                  _c(
                                    VRow,
                                    { staticClass: "mt-n3" },
                                    [
                                      _c(VCol, { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          " " + _vm._s(instrutor.nome) + " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(VTimelineItem, { attrs: { "hide-dot": "" } }, [
                    _c(
                      "h3",
                      { staticClass: "subtitle-1 primary--text ml-n4" },
                      [_vm._v(" ÁREAS DE ESPORTE ")]
                    ),
                  ]),
                  _vm._l(_vm.areasEsporte, function (area) {
                    return _c(
                      VTimelineItem,
                      { key: "areaEsporte_" + area.id, attrs: { small: "" } },
                      [
                        _c(
                          VRow,
                          { staticClass: "mt-n3" },
                          [
                            _c(VCol, { attrs: { cols: "6" } }, [
                              _vm._v(" " + _vm._s(area.nome) + " "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm.perfil.instrutorEsporte &&
                  _vm.cursosInstrutorEsporte.length > 0
                    ? _c(
                        "div",
                        [
                          _c(VTimelineItem, { attrs: { "hide-dot": "" } }, [
                            _c(
                              "h3",
                              { staticClass: "subtitle-1 primary--text ml-n4" },
                              [_vm._v(" INSTRUTOR DE ESPORTE ")]
                            ),
                          ]),
                          _vm._l(
                            _vm.cursosInstrutorEsporte,
                            function (instrutor) {
                              return _c(
                                VTimelineItem,
                                {
                                  key: "instrutorEsporte_" + instrutor.id,
                                  attrs: { small: "" },
                                },
                                [
                                  _c(
                                    VRow,
                                    { staticClass: "mt-n3" },
                                    [
                                      _c(VCol, { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          " " + _vm._s(instrutor.nome) + " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { align: "center" } },
        [
          _c(VCol, { attrs: { cols: "2" } }),
          _c(VCol, { attrs: { cols: "8" } }, [
            _c(
              "h2",
              {
                staticClass:
                  "title primary--text text--darken-1 text-no-wrap mt-0 ml-2",
              },
              [_vm._v(" PREFERÊNCIAS DE TRABALHO ")]
            ),
          ]),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(VCol, { attrs: { cols: "2" } }),
          _c(VCol, { attrs: { cols: "8" } }, [
            _c(
              "ol",
              { staticStyle: { "padding-left": "37px" } },
              _vm._l(_vm.perfil.perfilPreferencias, function (pp) {
                return _c(
                  VRow,
                  { key: pp.preferencia.id, staticClass: "my-2" },
                  [
                    _c("li", [
                      _c("b", { staticClass: "secondary--text" }, [
                        _vm._v(_vm._s(pp.preferencia.nome) + ":"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.itemPreferenciaDescricao(pp.itemPreferencia)
                          ) +
                          " "
                      ),
                    ]),
                  ]
                )
              }),
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-end mb-1" },
        [
          _c(
            VTooltip,
            {
              attrs: { "max-width": "400", top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            attrs: { color: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.getRelatorio()
                              },
                            },
                          },
                          on
                        ),
                        [
                          _c(VIcon, [_vm._v("get_app")]),
                          _vm._v(" BAIXAR PDF "),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("span", [
                _vm._v(
                  "Clique para baixar o relatório dos dados em formato PDF."
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }